interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const btn =
    "flex h-9 min-w-9 cursor-pointer items-center justify-center rounded-md border px-2 text-sm transition";

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className={`${btn} border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => onChange(1)}
            className={`${btn} border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-400`}
          >
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-500">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${btn} ${
            p === page
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-400"
          }`}
        >
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-foreground-500">…</span>}
          <button
            type="button"
            onClick={() => onChange(totalPages)}
            className={`${btn} border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-400`}
          >
            {totalPages}
          </button>
        </>
      )}

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className={`${btn} border-background-200 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}